import axios from 'axios';

// CRIA A NOVA INSTÂNCIA DO AXIOS
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL // URL BASE DO SERVIDOR
});


// CONFIGURAÇÃO DOS HEADERS
instance.interceptors.request.use(
    async (config) => {
        // Envia api-key para a api nas requisições
        config.headers['x-api-key'] = process.env.REACT_APP_API_KEY;
        return config;

    }, (error) => {
        console.error('ERROR - AXIOS CONFIG:', error);
        return Promise.reject(error);
    }
)


// CONFIGURAÇÃO DAS RESPOSTAS DE ERRO
instance.interceptors.response.use(
    (response) => {
        return response;

    }, (error) => Promise.reject(error)
)


export default instance;